import { formatWorkHistoryDuration } from '@offerzen/pinata-shame'

export const formatWorkHistories = workHistoriesData => {
  if (!workHistoriesData) return []

  const formattedData = workHistoriesData.map(job => {
    const { id, company, position, description, start, end, stillThere, skills, linkedProjects } = job
    return {
      id,
      company,
      jobTitle: position,
      description,
      startDate: start,
      endDate: end,
      duration: formatWorkHistoryDuration(start, end, stillThere),
      stillThere,
      skills,
      linkedProjects: linkedProjects ?? [],
    }
  })
  return formattedData
}

/**
 * Selects the salary conversion for the candidate, given the hiring teams currency code and remuneration period,
 * and the exchange rates for the candidate's original currency.
 * @param {Object} params
 * @param {Object[]} params.salaryConversions - The candidate's salary conversions.
 * @param {Object} params.hiringTeam - The member's hiring team.
 * @param {Object[]} [params.exchangeRates] - The exchange rates.
 * @returns
 */
export const selectSalaryConversion = ({ salaryConversions, hiringTeam, exchangeRates = [] }) => {
  if (!salaryConversions?.length || !hiringTeam) return {}

  const hiringTeamCurrencyCode = hiringTeam.currencyCode.toUpperCase()
  const salaryConversion = salaryConversions.find(
    sc => sc.currencyCode === hiringTeamCurrencyCode && sc.remunerationPeriod === hiringTeam.remunerationPeriod?.toUpperCase(),
  )
  const candidateExchangeRate = exchangeRates.find(rate => rate.currencyCode === salaryConversion.originalCurrencyCode)

  const salaryConversionCopy = { ...salaryConversion }
  salaryConversionCopy.exchangeRateMultiplier = candidateExchangeRate?.multiplier
  salaryConversionCopy.exchangeRateCode = hiringTeamCurrencyCode
  salaryConversionCopy.isCalculated = salaryConversion.calculated
  delete salaryConversionCopy.calculated

  return salaryConversionCopy
}
